export const ADS = 'ADS';
export const PAGINATION_CHANGE = 'PAGINATION_CHANGE';
export const NAVIGATION_CHANGE = 'NAVIGATION_CHANGE';
export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';
export const DRAWER_OPEN = 'DRAWER_OPEN';
export const DRAWER_CLOSE = 'DRAWER_CLOSE';
export const COMMENT_REPLY_SET = 'COMMENT_REPLY_SET';
export const COMMENT_REPLY_CANCEL = 'COMMENT_REPLY_CANCEL';
export const INIT_DATA_UPDATE = 'INIT_DATA_UPDATE';
export const USER_DEVICE_FINGERPRINT_HASH_SET = 'USER_DEVICE_FINGERPRINT_HASH_SET';
export const USER_DEVICE_FINGERPRINT_HASH_GET = 'USER_DEVICE_FINGERPRINT_HASH_GET';